/* GENERATED FILE - DO NOT EDIT! */
define(['underscore'], function(_) {
  return function(context) {
    var __t, __p = '',
      __j = Array.prototype.join,
      print = function() {
        __p += __j.call(arguments, '');
      };
    __p += '<div class="delete-payment-confirm"><h3>Delete this payment method?</h3><p>You will need to create a new payment method the next time you checkout.</p><button class="button button--red delete-payment-confirm__button">Delete</button><button class="button secondary-button overlay-close">Cancel</button></div>';
    return __p;
  }
});